import {BaseSchemaDataModel, BaseSchemaModel} from "./base-schema-model";
import {SCHEMA_TYPE} from "./consts";
import {AddressSchemaModel} from "./address-schema-model";

export class LocationSchemaDataModel extends BaseSchemaDataModel {
  location: String;
  maximumAttendeeCapacity: Number;
  address: AddressSchemaModel;
}

export class LocationSchemaModel extends BaseSchemaModel {
  model: LocationSchemaDataModel;

  constructor(model: LocationSchemaModel) {
    super(SCHEMA_TYPE.place, model.name, model.url);

    this.model = model;
  }

  get typeParams(): String {
    return this.type ? `"@type":"${this.type}"` : `` ;
  }

  get maximumAttendeeCapacityParams(): String {
    return this.model.maximumAttendeeCapacity ? `,"maximumAttendeeCapacity":"${this.model.maximumAttendeeCapacity}"` : ``;
  }

  get addressParams(): String {
    return this.model.address ? `,"address":${this.model.address.toString()}` : ``;
  }

  toString(): String {
    return `{${this.typeParams}${this.nameParams}${this.addressParams}}`;
  }
}
